import {
  ELEMENT_DEFAULT,
  getNode,
  indent,
  KEY_INDENT,
  KeyboardHandler,
  outdent,
  TElement,
} from '@udecode/plate';
import { Editor, Range } from 'slate';

export const onKeyDownIndent: KeyboardHandler = (editor) => (e) => {
  if (e.key === 'Backspace' && editor.selection && Range.isCollapsed(editor.selection)) {
    const path = editor.selection.anchor.path.slice(0, editor.selection.anchor.path.length - 1);
    const node = getNode(editor, path) as TElement;
    if (
      node &&
      node[KEY_INDENT] !== undefined &&
      node.type === ELEMENT_DEFAULT &&
      Editor.isEmpty(editor, node)
    ) {
      e.preventDefault();
      outdent(editor);
      return;
    }
  }
  if (e.key === 'Tab' && !e.altKey && !e.ctrlKey && !e.metaKey) {
    e.preventDefault();
    e.shiftKey ? outdent(editor) : indent(editor);
  }
};
